import { render } from "./AlertModal.vue?vue&type=template&id=7831f798&scoped=true"
import script from "./AlertModal.vue?vue&type=script&lang=js"
export * from "./AlertModal.vue?vue&type=script&lang=js"

import "./AlertModal.vue?vue&type=style&index=0&id=7831f798&lang=scss&scoped=true"

import exportComponent from "F:\\work\\1\\s\\vue-code\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7831f798"]])

export default __exports__